import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LAST_PATH_KEY = "yg_last_path";

// Görsel Editör iframe'i (?edit=1) — kayıtlı rota geri yükleme/kaydetme YAPMA.
// Aksi halde aynı-origin iframe parent'ın sessionStorage'ını paylaşıp
// /site-inspector'a yönlenir ve sonsuz özyineleme oluşur.
const EDIT_MODE = typeof window !== "undefined" && new URLSearchParams(window.location.search).get("edit") === "1";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isFirstRender = useRef(true);

  // İlk mount'ta: eğer F5 atıldıysa ve farklı bir sayfadaysak, kaydedilen URL'ye geri dön
  useEffect(() => {
    if (EDIT_MODE) return;
    const saved = sessionStorage.getItem(LAST_PATH_KEY);
    if (saved && saved !== pathname && saved !== "/") {
      navigate(saved, { replace: true });
    }
  }, []);

  // Sayfa değiştiğinde URL'yi kaydet
  useEffect(() => {
    if (EDIT_MODE) return;
    sessionStorage.setItem(LAST_PATH_KEY, pathname);
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
